<script setup>
import { computed } from 'vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  knowledgebase: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['select', 'edit', 'delete']);

const handleCardClick = () => {
  emit('select', props.knowledgebase);
};

const handleEdit = () => {
  emit('edit', props.knowledgebase);
};

const icon = computed(() => {
  switch (props.knowledgebase.type) {
    case 'documents':
      return 'i-lucide-file';
    case 'event_documents':
      return 'i-lucide-file-signature';
    case 'catalog':
      return 'i-lucide-layout-grid';
    case 'gallery':
      return 'i-lucide-book-image';
    default:
      return 'i-lucide-folder';
  }

});

const isChild = computed(() => !!props.knowledgebase.parent_id);
</script>

<template>
  <td>
    <div
      class="text-slate-900 dark:text-slate-100 truncate cursor-pointer flex flex-row items-center align-center"
      :class="{ 'pl-8': isChild }"
      @click="handleCardClick"
    >
      <Icon :icon="icon" class="float-left mr-2 w-6 h-6" :size="48" />
      <span data-testid="knowledgebase-card-name">{{
        knowledgebase.name
      }}</span>
    </div>
  </td>
  <td className="text-sm">
    {{ knowledgebase.description }}
  </td>
  <td>
    <div class="button-wrapper">
      <NextButton
        icon="i-lucide-pen-line"
        md
        slate
        faded
        data-testid="knowledgebase-edit-button"
        @click="handleEdit"
      />
      <NextButton
        v-if="!knowledgebase.space_associated"
        icon="i-lucide-trash-2"
        md
        ruby
        faded
        data-testid="knowledgebase-delete-button"
        @click="$emit('delete', knowledgebase)"
      />
      <NextButton
        v-if="knowledgebase.space_associated"
        icon="i-lucide-orbit"
        md
        slate
        faded
        @click="$router.push({ name: 'settings_spaces_index' })"
      />
    </div>
  </td>
</template>
